import React from "react";

const LOGOS = [
  { name: "Counselling Cell — Lakshmibai College", src: "/assets/logos/lakshmibai-college.png" },
  { name: "Modern Academy, Indirapuram", src: "/assets/logos/modern-academy.png" },
  { name: "Northeastern University London", src: "/assets/logos/northeastern-london.png" },
  { name: "Resilience Lab", src: "/assets/logos/resilience-lab.png" },
];

export default function HomeAsSeenOnSection() {
  return (
    <section className="md-seen-on-section" data-testid="as-seen-on-section">
      <div className="md-container">
        <div className="text-center mb-2"><span className="md-label-eyebrow">Trusted Partners</span></div>
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-10" data-testid="as-seen-on-heading">
          As seen <span style={{ color: "var(--md-primary)" }}>on</span>
        </h2>
        <div className="md-seen-on-row" data-testid="as-seen-on-logos">
          {LOGOS.map((l) => (
            <div key={l.name} className="md-seen-on-logo" title={l.name} data-testid={`seen-on-${l.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <img src={l.src} alt={l.name} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
